import React, { useState, useEffect, useRef, useContext } from "react";
import Slider from "react-slick";
import { Link, useNavigate } from 'react-router-dom';
import { Row, Col, Media } from "reactstrap";
import CountDownComponent from "../shared/CountDownComponent";
import { AddProductToCart, AlreadyAddedProductToCart } from '../../../helpers/CartHelper';
import { useSelector, useDispatch } from 'react-redux';
import CustomerFavProductBox from './CustomerFavProductBox';
import Config from "../../../helpers/Config";
import { MakeApiCallAsync } from "../../../helpers/ApiHelpers";

import { makeProductShortDescription, replaceWhiteSpacesWithDashSymbolInUrl } from "../../../helpers/ConversionHelper";
import { GetDefaultCurrencySymbol, getLanguageCodeFromSession, TranslatedText, GetLocalizationControlsJsonDataForScreen } from "../../../helpers/CommonHelper";
import GlobalEnums from "../../../helpers/GlobalEnums";
import rootAction from "../../../stateManagment/actions/rootAction";

import ProductRatingStars from "./ProductRatingStars";
import { showErrorMsg } from "../../../helpers/ValidationHelper";

var bestSellerSetting = {
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};


const productCollection = [
  {
    "__typename": "Product",
    "id": 12,
    "title": "boho tops",
    "description": "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters,It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters.",
    "type": "fashion",
    "brand": "nike",
    "category": "Women",
    "price": 129,
    "new": false,
    "sale": false,
    "discount": 40,
    "stock": 45,
    "variants": [
      {
        "__typename": "VariantType",
        "id": "12.1",
        "sku": "sku12",
        "size": "xs",
        "color": "red",
        "image_id": 1211
      },
      {
        "__typename": "VariantType",
        "id": "12.2",
        "sku": "skul12",
        "size": "xs",
        "color": "pink",
        "image_id": 1212
      },
      {
        "__typename": "VariantType",
        "id": "12.3",
        "sku": "sku12s",
        "size": "xs",
        "color": "gray",
        "image_id": 1213
      },
      {
        "__typename": "VariantType",
        "id": "12.4",
        "sku": "sku12l",
        "size": "s",
        "color": "red",
        "image_id": 1211
      },
      {
        "__typename": "VariantType",
        "id": "12.5",
        "sku": "sku12l",
        "size": "s",
        "color": "pink",
        "image_id": 1212
      },
      {
        "__typename": "VariantType",
        "id": "12.6",
        "sku": "sku12l",
        "size": "s",
        "color": "gray",
        "image_id": 1213
      },
      {
        "__typename": "VariantType",
        "id": "12.7",
        "sku": "sku12l",
        "size": "m",
        "color": "red",
        "image_id": 1211
      },
      {
        "__typename": "VariantType",
        "id": "12.8",
        "sku": "sku12l",
        "size": "m",
        "color": "pink",
        "image_id": 1212
      },
      {
        "__typename": "VariantType",
        "id": "12.9",
        "sku": "sku12l",
        "size": "m",
        "color": "gray",
        "image_id": 1213
      }
    ],
    "images": [
      {
        "__typename": "ImageType",
        "image_id": 1211,
        "id": "12.1",
        "alt": "red",
        "src": "pro3/22.jpg"
      },
      {
        "__typename": "ImageType",
        "image_id": 1212,
        "id": "12.2",
        "alt": "pink",
        "src": "pro3/27.jpg"
      },
      {
        "__typename": "ImageType",
        "image_id": 1213,
        "id": "12.3",
        "alt": "black",
        "src": "pro3/38.jpg"
      }
    ]
  }
]

const TodayHotDeal = () => {
  const [state, setState] = useState({ nav1: null, nav2: null });
  const slider1 = useRef(null);
  const slider2 = useRef(null);
  const dispatch = useDispatch();
  const [HotDealCartItem, setHotDealCartItem] = useState({
    Quantity: 0
  });
  const [HotProduct, setHopProduct] = useState({});
  const [TargetProduct, setTargetProduct] = useState(null);
  const [adminPanelBaseURL, setBaseUrl] = useState(Config['ADMIN_BASE_URL']);
  const [CustomerFavouritProd, setCustomerFavouriteProd] = useState([]);
  const [LocalizationLabelsArray, setLocalizationLabelsArray] = useState([]);




  useEffect(() => {
    setState({
      nav1: slider1.current,
      nav2: slider2.current,
    });
  }, []);


  useEffect(() => {
    // declare the data fetching function
    const dataOperationInUseEffect = async () => {


      const headers = {

        Accept: 'application/json',
        'Content-Type': 'application/json',

      }


      const param = {
        requestParameters: {

          recordValueJson: "[]",
        },
      };


      const response = await MakeApiCallAsync(Config.END_POINT_NAMES['GET_LATEST_HOT_PRODUCT'], null, param, headers, "POST", true);
      if (response != null && response.data != null) {
        let hProduct = JSON.parse(response.data.data);

        setHopProduct(hProduct != null && hProduct != undefined ? hProduct[0] : {});
        updateQTY(hProduct[0].ProductId);
      }
      const responseCustomerFav = await MakeApiCallAsync(Config.END_POINT_NAMES['GET_CUSTOMER_FAVOURITE_PRODUCTS'], null, param, headers, "POST", true);
      if (responseCustomerFav != null && responseCustomerFav.data != null) {
        let cusFav = JSON.parse(responseCustomerFav.data.data);
        setCustomerFavouriteProd(cusFav);

      }


    }

    // call the function
    dataOperationInUseEffect().catch(console.error);


    // declare the data fetching function
    const dataOperationFunc = async () => {
      updateQTY();
      //-- Get website localization data
      let arryRespLocalization = await GetLocalizationControlsJsonDataForScreen(GlobalEnums.Entities["ProductDetail"], null);
      if (arryRespLocalization != null && arryRespLocalization != undefined && arryRespLocalization.length > 0) {
        await setLocalizationLabelsArray(arryRespLocalization);
      }
    }
    // call the function
    dataOperationFunc().catch(console.error);
  }, [])


  function updateCartLocal(cartItems) {
    localStorage.setItem("cartItems", JSON.stringify(cartItems));
    dispatch(rootAction.cartAction.setCustomerCart(JSON.stringify(cartItems)));
    dispatch(rootAction.cartAction.SetTotalCartItems((cartItems).length));
  }
  function updateQTY(ProductId1 = null) {
    if (ProductId1 == null) {
      ProductId1 = HotProduct.ProductId;
    }
    const cartProductInfo = AlreadyAddedProductToCart(ProductId1);
    if (cartProductInfo != false) {
      setHotDealCartItem(cartProductInfo[0]);
    }
  }

  const handleSubtractQuantity = (item) => {


    let cartItems = JSON.parse(localStorage.getItem("cartItems"))
    let qty = cartItems?.find(x => x.ProductId == item.ProductId).Quantity;
    if (qty > 1) {

      let IndexPrd = cartItems.findIndex((obj => obj.ProductId == item.ProductId));
      cartItems[IndexPrd].Quantity = ((qty) - 1);

      updateCartLocal(cartItems);

      updateQTY();
    } else {
      let IndexPrd = cartItems.findIndex((obj => obj.ProductId == item.ProductId));
      cartItems.splice(IndexPrd, 1);
      setHotDealCartItem({
        Quantity: 0
      });
      //--store in storage
      updateCartLocal(cartItems);
      //--update in "cartItems"

      updateQTY();
    }
  }

  const handleAddQuantity = (item, targetbtn, parent_class) => {

    let cartItems = JSON.parse(localStorage.getItem("cartItems"))

    let qty = cartItems?.find(x => x.ProductId == item.ProductId).Quantity;

    if (item.OrderMaximumQuantity != undefined && item.OrderMaximumQuantity != null && item.OrderMaximumQuantity > 0) {
      if ((qty + 1) > item.OrderMaximumQuantity) {
        showErrorMsg(`Can not add more than ${item.OrderMaximumQuantity} for this product`);
        return false;
      }
    }


    AddImageToCart(targetbtn, parent_class)

    let IndexPrd = cartItems.findIndex((obj => obj.ProductId == item.ProductId));
    cartItems[IndexPrd].Quantity = ((qty) + 1);

    //--store in storage
    updateCartLocal(cartItems);

    //--update in "cartItems"
    updateQTY();
  }
  const AddImageToCart = (targetbtn, parent_class) => {
    if (targetbtn === null) {
      targetbtn = TargetProduct;
    }
    let target = function (e, t) {
      for (; e && e !== document; e = e.parentNode)
        if (e.matches(t))
          return e;
      return null
    }(targetbtn, parent_class);
    let shopping_cart = document.getElementsByClassName("icon-shopping-cart")[0]
      , product_image = target.querySelector(".img-fluid")
      , product_left = target.getBoundingClientRect().left
      , product_top = target.getBoundingClientRect().top
      , cart_left = shopping_cart.getBoundingClientRect().left
      , cart_top = shopping_cart.getBoundingClientRect().top
      , new_image = product_image.cloneNode(!0);
    new_image.style = "z-index: 11111; width: 100px; height:100px;opacity:1; position:fixed; top:" + product_top + "px;left:" + product_left + "px;transition: left 1s, top 1s, width 1s, height 1s,opacity 1s cubic-bezier(1, 1, 1, 1);border-radius: 50%; overflow: hidden; box-shadow: 0 21px 36px rgba(0,0,0,0.1)";
    var new_image_doc = document.body.appendChild(new_image);
    setTimeout(() => {
      new_image.style.left = cart_left + "px";
      new_image.style.top = cart_top + "px";
      new_image.style.width = "40px";
      new_image.style.height = "40px";
      new_image.style.opacity = "0";
    }, 200);

    setTimeout(() => {
      new_image_doc.parentNode.removeChild(new_image_doc);
    }, 1e3);

  }
  let isOutOfStock =HotProduct.StockQuantity == null || HotProduct.StockQuantity == undefined || HotProduct.StockQuantity < 1;        

  const HandleAddToCart = (item, targetbtn, parent_class) => {
    if (!(item.StockQuantity != null && item.StockQuantity != undefined && item.StockQuantity > 0)) {
      showErrorMsg("Product out of stock!");
      return false;

    }
    if (item == undefined || item.ProductId == undefined || item.ProductId < 1) {
      return false;
    }

    let defaultImage = (item?.ProductImagesJson?.length > 0) ? item.ProductImagesJson[0].AttachmentURL : '';
    let cartItems = AddProductToCart(item.ProductId, 1, item.Price, [], item.TotalAttributes, defaultImage);

    if (cartItems != false) {
      AddImageToCart(targetbtn, parent_class)
    } else {
      return;
    }
    dispatch(rootAction.cartAction.setCustomerCart(cartItems));
    dispatch(rootAction.cartAction.SetTotalCartItems(JSON.parse(cartItems).length));
    updateQTY();

  }

  const { nav1, nav2 } = state;

  var settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    fade: true,
    infinite: true,
    dots: false,
  };

  var setting1 = {
    arrows: false,
    infinite:false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          vertical: false,
          slidesToShow: 3,
        },
      },
    ],
  };

  return (
    <section className="hot-deal b-g-white section-pb-space space-abjust">
      <div className="custom-container">
        <Row className="hot-2">
          <Col lg="12">
            {/* <!--title start--> */}
            <div className="title3 b-g-white text-center">
              <h4>today&#39;s hot deal</h4>
            </div>
            {/* <!--titel end--> */}
          </Col>
          <Col lg="9">
            <div className="slide-1 no-arrow">
              <div>
                <div className="hot-deal-contain deal-abjust">


                  <Row className="row hot-deal-subcontain">
                    <Col lg="4" md="4">
                      <div className="hotdeal-right-slick border-0">
                        <Slider asNavFor={nav1} ref={(slider) => (slider2.current = slider)} {...settings}>
                          {HotProduct &&
                            HotProduct.ProductImagesJson?.map((img, i) => {
                              return (
                                <div key={i}>
                                  <Media src={adminPanelBaseURL + img.AttachmentURL} alt="hot-deal" className="img-fluid  " />
                                </div>
                              );
                            })}
                        </Slider>
                      </div>
                    </Col>
                    <Col lg="6" md="6">

                      {HotProduct != undefined && HotProduct != null ?
                        <div className="hot-deal-center" style={{ display: "block" }}>
                          <div>
                            <div>
                              {/* <h5>{makeProductShortDescription(HotProduct?.ProductName, 33)} </h5> */}

                              <Link to={`/${getLanguageCodeFromSession()}/product-detail/${HotProduct.ProductId}/${replaceWhiteSpacesWithDashSymbolInUrl(HotProduct.CategoryName) ?? "shop"}/${replaceWhiteSpacesWithDashSymbolInUrl(HotProduct.ProductName)}`}>
                                <h5 >{makeProductShortDescription(HotProduct.ProductName, 33)}</h5>
                              </Link>

                            </div>
                            <ProductRatingStars Rating={HotProduct?.Rating == undefined || HotProduct?.Rating == null ? 5 : HotProduct?.Rating} />

                            <div>
                              <p>
                                {makeProductShortDescription(HotProduct?.ShortDescription, 208)}
                              </p>

                              <div className="product-buttons">
                                {HotDealCartItem.Quantity === 0 ? <> {!isOutOfStock?<> <Link
                                  to="#"
                                  className="btn btn-normal p-3 w-100"
                                  id="lbl_prd_det_addcart"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    HandleAddToCart(HotProduct, e.target, ".hot-deal-contain");
                                  }}
                                >
                                  {TranslatedText(LocalizationLabelsArray, "Add to Cart", "lbl_prd_det_add_to_request")}

                                </Link>
                                </>:<> <Link
                                to="#"
                                className="btn btn-normal p-3 w-100 disabled"
                                id="lbl_prd_det_out_of_stock"
                                onClick={(e) => {
                                    e.preventDefault();
                                }}
                            >
                                {TranslatedText(LocalizationLabelsArray, "Out Of Stock", "lbl_prd_det_out_of_stock")}

                            </Link></>}</> : <>
                                  <div
                                    className="d-flex md:h-9 overflow-hidden text-light w-100 w-full"
                                    style={{ background: "var(--theme-color3)" }}
                                  >
                                    <button
                                      onClick={() => { handleSubtractQuantity(HotProduct) }}
                                      className="border-0 cursor-pointer duration-200 focus:outline-0 hover:bg-accent-hover px-3 transition-colors"
                                      style={{ background: "var(--theme-color3)" }}
                                    >
                                      <span className="sr-only">minus</span>
                                      <svg
                                        fill="#ffffff"
                                        viewBox="0 0 24 24"
                                        stroke="#ffffff"
                                        className="h-3 w-3 stroke-2.5"
                                      >
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M20 12H4" />
                                      </svg>
                                    </button>
                                    <div
                                      className="align-items-center d-flex flex-1 font-semibold justify-content-center px-3 text-sm"
                                    >
                                      {HotDealCartItem.Quantity}
                                    </div>
                                    <button
                                      onClick={(e) => { handleAddQuantity(HotProduct, e.target, ".hot-deal-contain") }}
                                      className="border-0 cursor-pointer duration-200 focus:outline-0 hover:bg-accent-hover p-2 px-3 transition-colors"
                                      style={{ background: "var(--theme-color3)" }}
                                    >
                                      <span className="sr-only">plus</span>
                                      <svg
                                        fill="#ffffff"
                                        viewBox="0 0 24 24"
                                        className="stroke-2.5 w-4"
                                        stroke="#ffffff"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                                        />
                                      </svg>
                                    </button>
                                  </div>

                                </>}
                              </div>
                            </div>
                            {
                              HotProduct?.DiscEndDate != null && HotProduct?.DiscEndDate != undefined
                                ?
                                <CountDownComponent endDate={HotProduct?.DiscEndDate} />
                                :
                                <>
                                </>
                            }

                          </div>
                        </div>
                        :
                        <>
                        </>
                      }
                    </Col>
                    <Col md="2">
                      <div className="hotdeal-right-nav">
                        <Slider
                          asNavFor={nav2}
                          ref={(slider) => (slider1.current = slider)}
                          vertical={true}
                          {...setting1}
                          slidesToShow={2}
                          swipeToSlide={true}
                          focusOnSelect={true}
                          verticalSwiping={true}>
                          {HotProduct &&
                            HotProduct.ProductImagesJson?.map((img, i) => {
                              return (
                                <div key={i}>
                                  <Media src={adminPanelBaseURL + img.AttachmentURL} alt="hot-deal" className="img-fluid" />
                                </div>
                              );
                            })}
                        </Slider>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </Col>
          <Col lg="3">
            <div>
              <div className="media-banner border-0">
                <div className="media-banner-box">
                  <div className="media-heading">
                    <h5>Customer Favorites</h5>
                  </div>
                </div>

                {CustomerFavouritProd && CustomerFavouritProd.map((item, i) => (


                  <CustomerFavProductBox item={item} key={item.ProductId} />
                ))}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default TodayHotDeal;
